__webpack_require__.p = "/reports-candidates-hires-work-location-details/referrals-hub/";